import { Box, LinearProgress } from '@mui/material';

export const LoaderPage = () => {
    return (
        <Box sx={{ backgroundColor: '#F1F3F7', height: '100vh' }}>
            <Box sx={{ width: '100%', top: 0, left: 0 }}>
                <LinearProgress
                    sx={{
                        color: 'primary',
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: '#1BABE2'
                        },
                        backgroundColor: '#FFF'
                    }}
                />
            </Box>
        </Box>
    );
};
